import dayjs from 'dayjs';

export enum EDoctorCareer {
  Current = 'CURRENT',
  Past = 'PAST',
  Graduation = 'GRADUATION',
  Completion = 'COMPLETION',
  Unknown = 'UNKNOWN',
}

export enum EAffiliationType {
  Doctornow = 'DOCTORNOW',
  Hospital = 'HOSPITAL',
  Pharmacy = 'PHARMACY',
  Unknown = 'UNKNOWN',
}

export interface MagazineByAuthorPublicIdVo {
  totalCount: number;
  totalPageCount: number;
  magazines: MagazineByAuthorPublicIdModel[];
}
export class MagazineAuthorModel {
  readonly affiliation: {
    readonly affiliationType: EAffiliationType;
    readonly affiliationPid: string;
    readonly name: string;
  } | null;
  readonly career: {
    readonly careerType: EDoctorCareer;
    readonly content: string;
    readonly id: string;
    readonly isRepresentative: boolean;
  }[];
  readonly name: string;
  readonly profileDescription: string;
  readonly profileImage: string;
  readonly publicId: string;

  constructor(_magazineAuthor: {
    affiliation: {
      affiliationType: EAffiliationType;
      affiliationPid: string;
      name: string;
    } | null;
    career: {
      careerType: EDoctorCareer;
      content: string;
      id: string;
      isRepresentative: boolean;
    }[];
    name: string;
    profileDescription: string;
    profileImage: string;
    publicId: string;
  }) {
    this.affiliation = _magazineAuthor.affiliation;
    this.career = _magazineAuthor.career;
    this.name = _magazineAuthor.name;
    this.profileDescription = _magazineAuthor.profileDescription;
    this.profileImage = _magazineAuthor.profileImage;
    this.publicId = _magazineAuthor.publicId;
  }

  isMagazineByDoctor() {
    return this.affiliation?.affiliationType === EAffiliationType.Hospital;
  }

  isMagazineByDoctornow() {
    return this.affiliation?.affiliationType === EAffiliationType.Doctornow;
  }

  getDisplayDoctorName() {
    if (this.isMagazineByDoctor()) {
      return `${this.name} 의사`;
    }
    return this.name;
  }

  getProfileDescription() {
    return this.profileDescription;
  }

  getDisplayCareerType(careerType: EDoctorCareer) {
    switch (careerType) {
      case EDoctorCareer.Current:
        return '현';
      case EDoctorCareer.Past:
        return '전';
      case EDoctorCareer.Graduation:
        return '졸업';
      case EDoctorCareer.Completion:
        return '수료';
      case EDoctorCareer.Unknown:
        return '';
    }
  }

  hasCareer() {
    return this.career.length > 0;
  }

  getDisplayCareer() {
    return this.career.map((career) => ({
      ...career,
      content: `${this.getDisplayCareerType(career.careerType)}) ${career.content}`,
    }));
  }
}

export class MagazineByAuthorPublicIdModel {
  readonly createdAt: number;
  readonly description: string;
  readonly titleImageUrl: string;
  readonly magazinePid: string;
  readonly mobileDescription: string;
  readonly title: string;
  readonly mobileTitle: string;

  constructor(_magazineByAuthorPublicId: {
    createdAt: number;
    description: string;
    titleImageUrl: string;
    magazinePid: string;
    mobileDescription: string;
    title: string;
    mobileTitle: string;
  }) {
    this.createdAt = _magazineByAuthorPublicId.createdAt;
    this.description = _magazineByAuthorPublicId.description;
    this.titleImageUrl = _magazineByAuthorPublicId.titleImageUrl;
    this.magazinePid = _magazineByAuthorPublicId.magazinePid;
    this.mobileDescription = _magazineByAuthorPublicId.mobileDescription;
    this.title = _magazineByAuthorPublicId.title;
    this.mobileTitle = _magazineByAuthorPublicId.mobileTitle;
  }

  getFormattedCreatedAt() {
    return dayjs(this.createdAt).format('YYYY.MM.DD');
  }
}
